module.exports = __webpack_public_path__ + "static/img/section-2.eb48773.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/section-2.jpg
// module id = 4PZo
// module chunks = 1